var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.91425 6.81068L12.2072 2.24597C12.5982 1.83022 12.5982 1.15822 12.2072 0.742474C11.8162 0.326727 11.1842 0.326727 10.7933 0.742474L6.50025 5.30718L2.20725 0.742474C1.81625 0.326727 1.18425 0.326727 0.79325 0.742474C0.40225 1.15822 0.40225 1.83022 0.79325 2.24597L5.08625 6.81068L0.79325 11.3754C0.40225 11.7911 0.40225 12.4631 0.79325 12.8789C0.98825 13.0862 1.24425 13.1904 1.50025 13.1904C1.75625 13.1904 2.01225 13.0862 2.20725 12.8789L6.50025 8.31417L10.7933 12.8789C10.9882 13.0862 11.2443 13.1904 11.5002 13.1904C11.7562 13.1904 12.0122 13.0862 12.2072 12.8789C12.5982 12.4631 12.5982 11.7911 12.2072 11.3754L7.91425 6.81068Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.06bd911360713f9b3b344750fdf71572.svg";
export { ForwardRef as ReactComponent };